import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
);

export enum StripeBtnTypes {
  Cars = 'CARS',
  Hotel = 'HOTEL',
  Condo = 'CONDO',
  Weeks = 'WEEKS'
}

export enum StripeChargeStatus {
  PENDING_EXPRESS = 'PendingExpress',
}
